import React, { useState, useEffect } from 'react'
import BlogLoader from './blog-loader'
import { useEffectAsync, useData } from '../../hooks/async-hooks'
import { useAppState, useParameters, useTranslation } from '../../utils'
import { getPages, getPagesId, getPagesIdLang, getTravel_infosId, getTravel_infosIdLang, getAmbassadorsId, getAmbassadorsIdLang, getDestinationsId, getDestinationsIdLang, getPdfsId, getTravel_infos, getAmbassadors, getDestinations, getPdfs, getPress_releasesId, getPress_releasesIdLang, getPress_releases } from '../../services/api'
import { changeLanguage, PostCollections, prepareCategories, blogCategoryUrl, useAddTargetBlankAndUrls, removeOldUrlsDivsAndAnchors } from './utils'
import moment from 'moment'
import { updateLinksInText, addImgSrc } from '../../lib/blog-utils/blog-post-formatter'
import { BlogPage } from '../../models/BlogPage'
import { NamedObject } from '../../models/NamedObject'
import { Link } from 'react-router-dom'
import { element } from 'prop-types'
import { useSupportedLanguage } from './menu-bar/menu'
import BlogLoginForm from './blog-login-form'
import { getSlicedPost } from '../../lib/blog-utils/blog-post-preview'
import { BlogPost } from '../../models/BlogPost'
import MetaTags from 'react-meta-tags'

const abTestingValue = Math.random().toPrecision(2)
// localStorage.getItem('abTestingValue') ? "" : localStorage.setItem('abTestingValue', abTestingValue)
// const abTestingException = localStorage.getItem('abTestingValue') ?? 0
const abTestingException = "0"

const currentUrl = ""
const pressReleasesException = currentUrl.indexOf('press-releases') != -1

const functionsToCollections: Record<Exclude<PostCollections, "post" | "all">, {
  byId: (id: number) => Promise<BlogPage>
  byIdLang: (id: number, lang: string) => Promise<BlogPage>
  bySlug: (opts: { slug: string, lang: string }) => Promise<BlogPage[]>
}> = {
  "travel-info": {
    byId: id => getTravel_infosId(id, {}),
    byIdLang: getTravel_infosIdLang,
    bySlug: getTravel_infos
  },
  ambassadors: {
    byId: id => getAmbassadorsId(id, {}),
    byIdLang: getAmbassadorsIdLang,
    bySlug: getAmbassadors
  },
  "press-releases": {
    byId: id => getPress_releasesId(id ),
    byIdLang: getPress_releasesIdLang,
    bySlug: getPress_releases
  },
  destination: {
    byId: id => getDestinationsId(id, {}),
    byIdLang: getDestinationsIdLang,
    bySlug: getDestinations
  },
  ebook: {
    byId: getPdfsId,
    byIdLang: getPagesIdLang,
    bySlug: getPdfs
  },
  page: {
    byId: getPagesId,
    byIdLang: getPagesIdLang,
    bySlug: getPages,
  }
}

export function BlogInfoPageDispaly({ post, lang, collection, isLoggedIn }: { post: BlogPage & { categories?: NamedObject[], tags?: NamedObject[] }, lang: string, collection: PostCollections, isLoggedIn: boolean }) {
  const postContent = getContentForLoginState(post)
  const { keyCategory, displayCategories } = prepareCategories(post.categories);
  const [pressReleasesException, setPressReleasesException] = useState(false)
  const { t } = useTranslation();
  const routeParam = useParameters<{
    searchType?: "category" | "tag" | "text",
    searchText?: string,
    lang: string,
  }>();
  const url = encodeURI(`${HOST_URL}/${routeParam.lang}/content/${post.slug}`)
  removeOldUrlsDivsAndAnchors(true, `${postContent}`);
  useAddTargetBlankAndUrls(".blog-post a", ".crp-tile.ftg- ", `${postContent}`)
  useSupportedLanguage(collection, post);
  function getContentForLoginState(post: BlogPage & { categories?: NamedObject[] }) {
    const postContent = updateLinksInText(addImgSrc(post.content?.rendered!))
    // if (!isLoggedIn && abTestingException > "0.5") {
    //   return getSlicedPost(postContent, false)
    // }
    // else if (!isLoggedIn && abTestingException <= "0.5") {
    //   return getSlicedPost(postContent, true)
    // }
    return postContent
  }
  return <div className='blog-post'>
    <MetaTags>
      <title>{post.title ? post.title.rendered! : t('seo_title_home')}</title>
    </MetaTags>
    {keyCategory && <Link to={blogCategoryUrl(lang, keyCategory.slug)}><h4 dangerouslySetInnerHTML={{ __html: keyCategory.name }}></h4></Link>}
    <h1 dangerouslySetInnerHTML={{ __html: post.title?.rendered! }} />

    <div className='meta-wrapper'>
      <div className='blog-post-date'>{moment(post.date).locale(lang ?? 'en').format("MMM D YYYY")}</div>
      {displayCategories &&
        <div className='article-tags blog-post-tags'>{displayCategories.map((c) =>
          <Link key={c.id} className='tag-link' to={blogCategoryUrl(lang, c.slug)}
            dangerouslySetInnerHTML={{ __html: c.name }}></Link>)}
        </div>}
    </div>
    {!post.jetpack_featured_media_url ? <></> : <img width="450" height="auto" src={post.jetpack_featured_media_url} />}
    <div className="entry-content herald-entry-content">
      {isLoggedIn ? <div dangerouslySetInnerHTML={{ __html: postContent }} /> : (abTestingException > "0.5" || pressReleasesException ? <div dangerouslySetInnerHTML={{ __html: postContent }} /> : null)}
      {/*{!isLoggedIn && !pressReleasesException ?*/}
      {/*  <div className="blog-fader-loginFormContainer" >*/}
      {/*    <div className="blogPostfader"></div>*/}
      {/*    <BlogLoginForm />*/}
      {/*  </div> : null}*/}
    </div>
    <p id="share-wrapper-title"> Share this article in:</p>
    <div className='share-wrapper'>
      <a rel='noopener noreferrer' target="_blank" className='share-button facebook' href={`https://facebook.com/sharer/sharer.php?u=${url}`}></a>
      <a rel='noopener noreferrer' target="_blank" className='share-button twitter' href={`https://twitter.com/share?url=${url}`}></a>
      <a rel='noopener noreferrer' target="_blank" className='share-button pinterest' href={`https://pinterest.com/pin/create/button/?url=${url}`}></a>
      <a rel='noopener noreferrer' target="_blank" className='share-button linkedin' href={`https://linkedin.com/sharing/share-offsite/?url=${url}`}></a>
    </div>
    <div className="border-bottom-separator" />
  </div>
}
export default BlogGenericPage;
export function BlogGenericPage({ collection }: { collection: Exclude<PostCollections, "post" | "all"> } ) {
  const params = useParameters<{
    blogSlug: string,
    lang: string
  }>();
  const { t } = useTranslation();
  const appState = useAppState();
  const isLoggedIn = !!appState.user
  const [] = useState<number[]>([]);
  const { data: [item], setData: setPosts, loading } = useData(() => {
    const [slug, slugLang] = params.blogSlug.split('--');
    return functionsToCollections[collection].bySlug({
      slug,
      lang: slugLang ?? params.lang
    })
  }, [params.blogSlug, params.lang]);

  useEffectAsync(async () => {
    if (!item) return;
    const translated = await changeLanguage({
      blog: item,
      language: params.lang,
      get: functionsToCollections[collection].byId,
      getByLang: functionsToCollections[collection].byIdLang
    });
    setPosts([translated]);
  }, [params.lang, item?.slug]);

  return (<div className="entry-content herald-entry-content">
    <div className="blogWrapper">
      {!loading && (item ? <BlogInfoPageDispaly lang={params.lang} post={item} collection={collection} isLoggedIn={isLoggedIn} /> : <div><p>{t('faulty-search')}.</p></div>)}
      {loading && <BlogLoader />}
    </div>
  </div>)
}
